import { CountryCode as CountryCodeEnum } from '@nzyme/i18n/Country.js';
import * as z from 'zod/mini';
export const CountryCode = z.enum(CountryCodeEnum);
//# sourceMappingURL=CountryCode.js.map